/* eslint-disable */
import React, { Component } from "react"
import * as ReactNavigation from "react-navigation"
import { connect } from "react-redux"
import AppNavigation from "./AppNavigation"
import SwiperContainerScreen from '../Containers/SwiperContainerScreen'
import { DrawerNavigator } from "react-navigation"
import {
  createReduxBoundAddListener,
  createReactNavigationReduxMiddleware,
} from 'react-navigation-redux-helpers';
import SwiperActions from '../Redux/SwiperRedux'
import SideBarScreen from '../Containers/SideBarScreen';
import LoginScreen from "../Containers/LoginScreen"
import { Keyboard, Linking, Platform } from 'react-native'

import AuthActions from '../Redux/AuthRedux'

import ChangePasswordScreen from "../Containers/ChangePasswordScreen"

class ReduxNavigation extends Component {
  constructor(props) {
    super(props)
    this.state = {
      authMode: null,
      code: null,
    }
    this.handleOpenURL = this.handleOpenURL.bind(this)
    this.deepLinkNavigation = this.deepLinkNavigation.bind(this)
    this.clearAuthMode = this.clearAuthMode.bind(this)
    // this.props.setMode(null, null)
  }

  componentDidMount() {
    // trial do both, for both platforms
    if (true || Platform.OS === 'android') {
      console.info("Linking.getInitialURL before call")
      Linking.getInitialURL().then(url => {
        console.info("Linking.getInitialURL response = " + url)
        if (url)
          this.deepLinkNavigation(url);
      })
    }
    //else {
      Linking.addEventListener('url', this.handleOpenURL);
    //}
  }

  componentWillUnmount () {
    Linking.removeEventListener('url', this.handleOpenURL);
  }

  // app is being launched from a url, eg: Reset Password
  handleOpenURL(event) {
    console.tron.display({
    name: `handleOpenURL`,
     preview :``,
    value: {
    state: event
    }
    })

    this.deepLinkNavigation(event.url)
  }

  deepLinkNavigation(url) {
    // https://medium.com/react-native-training/deep-linking-your-react-native-app-d87c39a1ad5e
    console.log(`deepLinkNavigation url: ${url}`)
    // krgovndev://?code=asd76sd7as65d765as
    // krgovndev://post?PostId=203320587&UserId=k34545h3iu5k
		// krgovndev://post?PostId=5wUWDbKwthO9B7&UserId=s8h2uG09N2CyA7
		// const parts = url.split('code=')
		const parts = url.split('?') // split can return an empty final element
		if (parts.length > 1 && parts[1] != '') {
			const baseUrl = parts[0]
			const query   = parts[1]
			const urlParts = baseUrl.split('//')
			let route = urlParts.length > 1 && urlParts[1] != '' ? urlParts[1] : 'code'
      // check if we are on web kargoe
      if (urlParts && (urlParts.length > 0) && (urlParts[0] == 'http:' || urlParts[0] == 'https:')) {
        // for web we have a real query, just use it
        if (query && query.length > 0) {
          let nameVal = query.split('=')
          if (nameVal && nameVal.length > 1) {
            if (nameVal[0] == 'code') route = 'code'
          }
        }
      }
			console.log(`deepLinkNavigation urlParts: ` + JSON.stringify(urlParts))
			console.log(`deepLinkNavigation baseUrl: ${baseUrl}`)
			console.log(`deepLinkNavigation route: ${route}`)
			console.log(`deepLinkNavigation query: ${query}`)
			const paramList = query.split('&')
			let params = {}
			if (paramList.length > 0 && paramList[0] != '') {
				paramList.forEach(param => {
					if (param.length > 0) {
						const parts = param.split('=')
						params[parts[0]] = parts[1]
					}
				})
				console.log(`deepLinkNavigation params: ` + JSON.stringify(params))
				switch (route) {
					case 'code':
						code = params['code']
						console.log(`deepLinkNavigation code: ${code}`)
						if (typeof code === 'string' && code.length > 1) // sanity check.  facebook app can send us here too w/ no code defined.
							this.setState({authMode: 'change-password', code})
						break;
					case 'post':
						console.log(`deepLinkNavigation post`)
						const { dispatch } = this.props
						setTimeout(() => { dispatch(AuthActions.setDeepLinkTask(params)) }, 2000)
						// dispatch(AuthActions.setDeepLinkTask(params))
						// this.props.setDeepLinkTask(params)
						break;
					default:
						console.log(`deepLinkNavigation unknown route`)
						break;
				}
			}
		}
  }

  clearAuthMode() {
    console.log(`ReduxNavigation clearAuthMode`)
    this.setState({authMode: null, code: null})
  }

  render() {
    console.log("redux nav render")
		// still need drawerMethods to avoid changes in SwiperContainerScreen
    const drawerMethods = {
    }
		// cannot move these lines to the contructor or the app locks up with the kargoe spinner
    const addListener = createReduxBoundAddListener("root");
    const { dispatch, nav } = this.props
    this.navigation = ReactNavigation.addNavigationHelpers({
      dispatch,
      state: nav,
      addListener,
    })
    const navigation = this.navigation
    this.props.setNavigation(this.navigation)
    if (this.state.authMode == 'change-password')
      return (
        <ChangePasswordScreen navigation={navigation} oneTimeCode={this.state.code} clearAuthMode={this.clearAuthMode} />
      )
    console.log("ready to render swiper container screen form redux nav sending screenProps = " + JSON.stringify(drawerMethods))
    return (
      <SwiperContainerScreen needsLoginTimeStamp={this.props.needsLoginTimeStamp} navigation={navigation} screenProps={drawerMethods} />
    )
  }
}

const mapStateToProps = state => ({
  nav: state.nav,
  auth: state.auth
})

/*
// app crashes when you navigate to different screens with this here
const mapDispatchToProps = (dispatch) => ({
  setDeepLinkTask: (taskInfo) => dispatch(AuthActions.setDeepLinkTask(taskInfo)),
})
*/

export default connect(mapStateToProps, null)(ReduxNavigation)
